<template>
  <div class="hpmePage">
    <!-- <div class="pcPage" v-if="$root.pcShow"> -->
    <!-- 导航弹窗 -->
    <my-menu :class="navShow ? 'on' : ''" @closeNav="closeNav"></my-menu>
    <div class="pcPage">
      <!-- 页面内容 -->
      <v-touch @swipeup="next" @swipedown="pre">
        <div class="fullPage" ref="fullPage">
          <div class="fullPageContainer" ref="fullPageContainer" @wheel="scroll ? mouseWheelHandle($event) : ''">
            <div class="section" :class="fullpage.current == 1 ? 'active' : ''">
              <home-page01 v-if="fullpage.current == 1 || fullpage.current == 2" @getWindowWidth="getWindowWidth"
                @move="move" @openSearch="() => {
                  searchShow = true;
                }
                  " @openMenu="() => {
    navShow = true;
  }
    "></home-page01>
            </div>
            <div class="section" :class="fullpage.current == 2 ? 'active' : ''">
              <home-page02 v-if="fullpage.current == 1 || fullpage.current == 2 || fullpage.current == 3" @move="move"
                @openSearch="() => {
                  searchShow = true;
                }
                  " @openMenu="() => {
    navShow = true;
  }
    "></home-page02>
            </div>
            <div class="section" :class="fullpage.current == 3 ? 'active' : ''">
              <home-page05 @move="move" @openSearch="() => {
                searchShow = true;
              }
                " @openMenu="() => {
    navShow = true;
  }
    "></home-page05>
            </div>
            <div class="section" :class="fullpage.current == 4 ? 'active' : ''">
              <home-page06 v-if="fullpage.current == 3 || fullpage.current == 4 || fullpage.current == 5" @move="move"
                @openSearch="() => {
                  searchShow = true;
                }
                  " @openMenu="() => {
    navShow = true;
  }
    "></home-page06>
            </div>
            <div class="section" :class="fullpage.current == 5 ? 'active' : ''">
              <home-page03 v-if="fullpage.current == 4 || fullpage.current == 5 || fullpage.current == 6" @move="move"
                @openSearch="() => {
                  searchShow = true;
                }
                  " @openMenu="() => {
    navShow = true;
  }
    "></home-page03>
            </div>
            <div class="section" :class="fullpage.current == 6 ? 'active' : ''">
              <home-page04 @move="move" @openSearch="() => {
                searchShow = true;
              }
                " @openMenu="() => {
    navShow = true;
  }
    " ref="homePage04"></home-page04>
            </div>
            <div class="section" :class="fullpage.current == 7 ? 'active' : ''">
              <home-page07 @move="move" @openSearch="() => {
                searchShow = true;
              }
                " @openMenu="() => {
    navShow = true;
  }
    " ref="homePage07"></home-page07>
            </div>
            <div class="section" :class="fullpage.current == 8 ? 'active' : ''">
              <home-page08 @move="move" @openSearch="() => {
                searchShow = true;
              }
                " @openMenu="() => {
    navShow = true;
  }
    " ref="homePage08"></home-page08>
            </div>
          </div>
        </div>
      </v-touch>

      <!-- 目录 -->
      <div class="m_dire" v-if="fullpage.current != 1 && fullpage.current != 8" :class="fullpage.current == 2 ||
        fullpage.current == 3 ||
        fullpage.current == 6 ||
        fullpage.current == 7
        ? 'm_direBlue'
        : ''
        ">
        <div class="m_direItem">
          <div class="m_direText" v-if="fullpage.current == 2" @click="$tools.blankPush('/jingzheDynamic')">
            京哲动态
          </div>
          <div class="m_direPoint" v-else @click="move(2)">
            <span>京哲动态</span>
          </div>
        </div>
        <div class="m_direItem">
          <div class="m_direText" v-if="fullpage.current == 3" @click="$tools.blankPush('/jingzheWelfare')">
            社会责任
          </div>
          <div class="m_direPoint" v-else @click="move(3)">
            <span>社会责任</span>
          </div>
        </div>
        <div class="m_direItem">
          <div class="m_direText" v-if="fullpage.current == 4" @click="$tools.blankPush('/cooperativePartner')">
            合作对象
          </div>
          <div class="m_direPoint" v-else @click="move(4)">
            <span>合作对象</span>
          </div>
        </div>
        <div class="m_direItem">
          <div class="m_direText" v-if="fullpage.current == 5" @click="$tools.blankPush('/areaExpertise')">
            业务领域
          </div>
          <div class="m_direPoint" v-else @click="move(5)">
            <span>业务领域</span>
          </div>
        </div>
        <div class="m_direItem">
          <div class="m_direText" v-if="fullpage.current == 6" @click="$tools.blankPush('/professionalPersonnel')">
            专业人员
          </div>
          <div class="m_direPoint" v-else @click="move(6)">
            <span>专业人员</span>
          </div>
        </div>
        <div class="m_direItem">
          <div class="m_direText" v-if="fullpage.current == 7" @click="$tools.blankPush('/onlineMessage')">
            联系我们
          </div>
          <div class="m_direPoint" v-else @click="move(7)">
            <span>联系我们</span>
          </div>
        </div>
        <div class="m_direItem">
          <div class="m_direText" v-if="fullpage.current == 8">底部导航</div>
          <div class="m_direPoint" v-else @click="move(8)">
            <span>底部导航</span>
          </div>
        </div>
      </div>

      <!-- 导航弹窗 -->
      <!-- <van-popup
        v-model="navShow"
        :style="{ height: '100%', width: '100%' }"
        style="z-index: 2000"
        @opened="initCurrent"
      >
        <div class="n_area">
          <div class="n_nav">
            <div></div>
            <div class="n_nav_right">
              <div alt="" class="t_logo t_logo03" />
            </div>
            <div class="n_nav_left">
              <i
                class="el-icon-close pointer"
                @click="
                  () => {
                    navShow = false;
                  }
                "
              ></i>
            </div>
          </div>
          <div class="n_menu">
            <div class="n_menuItem">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 0 ? 'n_left48' : ''"
                @click="jumpRouter('/')"
              >
                首页
              </div>
            </div>
            <div class="n_menuItem">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 1 ? 'n_bottom48' : ''"
                @click="
                  () => {
                    jumpRouter('/enterJingzhe');
                  }
                "
              >
                京哲介绍
                <div
                  class="n_menuItem_icon"
                  style="width: 18px; height: 18px"
                ></div>
              </div>
              <div class="n_menuItem_detail">
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 1 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/enterJingzhe');
                    }
                  "
                >
                  走进京哲
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 2 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/jingzheHonor');
                    }
                  "
                >
                  京哲荣誉
                </div>
              </div>
            </div>
            <div class="n_menuItem">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 2 * 200 ? 'n_bottom48' : ''"
                @click="
                  () => {
                    jumpRouter('/jingzheDynamic');
                  }
                "
              >
                京哲动态
                <div
                  class="n_menuItem_icon"
                  style="width: 18px; height: 18px"
                ></div>
              </div>
              <div class="n_menuItem_detail">
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 3 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/jingzheDynamic');
                    }
                  "
                >
                  京哲新闻
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 4 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/jingzheWelfare');
                    }
                  "
                >
                  京哲公益
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 5 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/jingzhePerformance');
                    }
                  "
                >
                  京哲业绩
                </div>
              </div>
            </div>
            <div class="n_menuItem">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 3 * 200 ? 'n_bottom48' : ''"
                @click="jumpRouter('/areaExpertise')"
              >
                专业领域
                <div
                  class="n_menuItem_icon"
                  style="width: 18px; height: 18px"
                ></div>
              </div>
              <div class="n_menuItem_detail">
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 6 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  公司法律事务
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 7 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  民事争议调解与诉讼
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 8 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  刑事辩护与风险防范
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 9 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  商事争端与仲裁
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 10 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  医药健康法律
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 11 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  房地产与建筑工程
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 12 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  债务重组与特殊资产处置
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 13 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  行政法律事务
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 14 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  涉外投融资与国际贸易
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 15 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  知识产权
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 16 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  政府法律事务
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 17 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  劳动与人力资源
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 18 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  公益法律援助中心
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 19 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  环境保护与矿产资源开发
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 20 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  娱乐与传媒
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 21 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  企业与家族财富传承
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 22 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  项目投资与并购
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 24 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  金融私募与风险投资
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 25 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  汽车
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 26 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/areaExpertiseDetail');
                    }
                  "
                >
                  民事交叉业务
                </div>
              </div>
            </div>
            <div class="n_menuItem" style="align-items: center">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 4 * 200 ? 'n_bottom48' : ''"
                @click="jumpRouter('/professionalPersonnel')"
              >
                专业人员
                <div
                  class="n_menuItem_icon"
                  style="width: 18px; height: 18px"
                ></div>
              </div>
              <div class="n_menuItem_detail n_right108">
                <div class="n_menuItem_search">
                  <div class="n_menuItem_input">
                    <input type="text" placeholder="按姓氏首字母搜索" />
                  </div>
                  <div
                    class="n_menuItem_btn"
                    @click="
                      () => {
                        jumpRouter('/professionalPersonnel');
                      }
                    "
                  >
                    搜索
                  </div>
                </div>
                <div class="n_menuItem_search">
                  <div class="n_menuItem_input">
                    <input type="text" placeholder="按律师姓名搜索" />
                  </div>
                  <div
                    class="n_menuItem_btn"
                    @click="
                      () => {
                        jumpRouter('/professionalPersonnel');
                      }
                    "
                  >
                    搜索
                  </div>
                </div>
                <div class="n_menuItem_search">
                  <div class="n_menuItem_input">
                    <el-select
                      v-model="value"
                      placeholder="按业务领域搜索"
                      ref="select"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="n_menuItem_btn"
                    @click="
                      () => {
                        jumpRouter('/professionalPersonnel');
                      }
                    "
                  >
                    搜索
                  </div>
                </div>
              </div>
            </div>
            <div class="n_menuItem">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 5 * 200 ? 'n_bottom48' : ''"
                @click="
                  () => {
                    jumpRouter('/cooperativePartner');
                  }
                "
              >
                合作对象
                <div
                  class="n_menuItem_icon"
                  style="width: 18px; height: 18px"
                ></div>
              </div>
              <div class="n_menuItem_detail">
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 24 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/cooperativePartner');
                    }
                  "
                >
                  合作对象
                </div>
              </div>
            </div>
            <div class="n_menuItem">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 6 * 200 ? 'n_bottom48' : ''"
                @click="
                  () => {
                    jumpRouter('/partyBuildingWork');
                  }
                "
              >
                党建工作
                <div
                  class="n_menuItem_icon"
                  style="width: 18px; height: 18px"
                ></div>
              </div>
              <div class="n_menuItem_detail">
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 25 * 200 ? 'n_bottom48' : ''"
                  @click="
                    () => {
                      jumpRouter('/partyBuildingWork');
                    }
                  "
                >
                  党建
                </div>
              </div>
            </div>
            <div class="n_menuItem">
              <div
                class="n_menuItem_label"
                @mouseenter="changeActive($event)"
                :class="currentTime >= 7 * 200 ? 'n_bottom48' : ''"
                @click="jumpRouter('/onlineMessage')"
              >
                联系我们
                <div
                  class="n_menuItem_icon"
                  style="width: 18px; height: 18px"
                ></div>
              </div>
              <div class="n_menuItem_detail">
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 26 * 200 ? 'n_bottom48' : ''"
                  @click="jumpRouter('/onlineMessage')"
                >
                  在线留言
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 27 * 200 ? 'n_bottom48' : ''"
                  @click="jumpRouter('/contactUs')"
                >
                  联系我们
                </div>
                <div
                  class="n_menuItem_detailItem n_bottom48"
                  :class="currentTime >= 28 * 200 ? 'n_bottom48' : ''"
                  @click="jumpRouter('/jobOpportunity')"
                >
                  工作机会
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-popup> -->

      <!-- 搜索弹窗 -->
      <van-popup v-model="searchShow" position="top" :style="{ height: '60%' }" :z-index="1500">
        <div class="searchArea">
          <div class="s_searchIcon pointer" @click="() => {
            searchShow = false;
          }
            ">
            <div class="s_close"></div>
          </div>
          <div class="s_nav">
            <div class="s_logo"></div>
          </div>
          <div class="s_title">探索京哲</div>
          <div class="s_mid">
            <div class="s_search">
              <div class="s_input">
                <input type="text" placeholder="搜索" name="" id="" v-model="searchText" />
              </div>
              <div class="s_goSearch">
                <div class="s_rightArrow pointer" @click="search(1)" v-loading="loading"></div>
              </div>
            </div>
            <div class="s_label">京哲智慧，开启未来</div>
          </div>
        </div>
      </van-popup>

      <myDeclaration ref="myDeclaration"></myDeclaration>
    </div>

    <!-- <div class="phonePage" v-else> -->
    <div class="phonePage">
      <div class="pt_nav">
        <div class="pt_nav_left">
          <img src="@/assets/images/logo01.png" alt="" v-if="phFullpage.current != 1 &&
            (phFullpage.current == 2 ||
              phFullpage.current == 4 ||
              phFullpage.current == 5 ||
              phFullpage.current == 7)
            " />
          <img src="@/assets/images/logo02.png" alt="" v-if="phFullpage.current != 1 &&
            phFullpage.current != 2 &&
            phFullpage.current != 4 &&
            phFullpage.current != 5 &&
            phFullpage.current != 7 &&
            phFullpage.current != 8
            " />
        </div>
        <div class="pt_nav_right">
          <div class="pt_text" :class="phFullpage.current == 2 ||
            phFullpage.current == 4 ||
            phFullpage.current == 5 ||
            phFullpage.current == 7
            ? 't_blue'
            : ''
            " :style="{
    color:
      phFullpage.current == 2 ||
        phFullpage.current == 4 ||
        phFullpage.current == 5 ||
        phFullpage.current == 7
        ? '#013060'
        : '#fff',
  }">
            <div class="mN_lag pointer">
              <div class="text">CN</div>
            </div>
          </div>
          <div class="pt_icon pointer" :class="phFullpage.current == 2 ||
            phFullpage.current == 4 ||
            phFullpage.current == 5 ||
            phFullpage.current == 7
            ? 'icon_search02'
            : 'icon_search01'
            " @click="() => {
    phSearchShow = true;
  }
    "></div>
          <div class="pt_icon pointer" :class="phFullpage.current == 2 ||
            phFullpage.current == 4 ||
            phFullpage.current == 5 ||
            phFullpage.current == 7
            ? 'icon_menu02'
            : 'icon_menu'
            " @click="() => {
    phNavShow = true;
  }
    "></div>
        </div>
      </div>

      <!-- 页面内容 -->
      <v-touch @swipeup="phNext" @swipedown="phPre">
        <div class="fullPage" ref="phFullPage">
          <div class="fullPageContainer" ref="phFullPageContainer">
            <div class="section" :ref="phFullpage.current == 1 ? 'active' : ''"
              :class="phFullpage.current == 1 ? 'active' : ''">
              <phonePage01></phonePage01>
            </div>
            <div class="section" :ref="phFullpage.current == 2 ? 'active' : ''"
              :class="phFullpage.current == 2 ? 'active' : ''">
              <phonePage02></phonePage02>
            </div>
            <div class="section" :ref="phFullpage.current == 3 ? 'active' : ''"
              :class="phFullpage.current == 3 ? 'active' : ''">
              <phonePage03></phonePage03>
            </div>
            <div class="section" :ref="phFullpage.current == 4 ? 'active' : ''"
              :class="phFullpage.current == 4 ? 'active' : ''">
              <phonePage04 ref="phonePage04"></phonePage04>
            </div>
            <div class="section" :ref="phFullpage.current == 5 ? 'active' : ''"
              :class="phFullpage.current == 5 ? 'active' : ''">
              <phonePage05></phonePage05>
            </div>
            <div class="section" :ref="phFullpage.current == 6 ? 'active' : ''"
              :class="phFullpage.current == 6 ? 'active' : ''">
              <phonePage06></phonePage06>
            </div>
            <div class="section" :ref="phFullpage.current == 7 ? 'active' : ''"
              :class="phFullpage.current == 7 ? 'active' : ''">
              <phonePage07 ref="phonePage07"></phonePage07>
            </div>
            <div class="section" :ref="phFullpage.current == 8 ? 'active' : ''"
              :class="phFullpage.current == 8 ? 'active' : ''">
              <phonePage08 ref="phonePage08" id="phonePage08Box"></phonePage08>
            </div>
          </div>
        </div>
      </v-touch>

      <!-- 移动端导航 -->
      <van-popup v-model="phNavShow" position="right" style="z-index: 2000" :style="{ height: '100%', width: '100%' }">
        <div class="phNav">
          <div class="pn_top">
            <div class="pnh_tr">
              <div class="pnh_search01"></div>
              <input type="text" placeholder="搜索" name="" id="" v-model="searchText" />
              <div class="pnh_rightArrow" @click="search(2)" v-loading="loading"></div>
            </div>
            <div class="pnh_tl">
              <div class="ptl_text">
                <div class="mN_lag pointer">
                  <div class="text">CN</div>
                </div>
              </div>
              <div class="pnh_close" @click="() => {
                phNavShow = false;
              }
                "></div>
            </div>
          </div>
          <div class="pn_area">
            <phoneMenu></phoneMenu>
          </div>
          <div class="pn_footer">
            <a href="http://jingzhe.ims-pro.cn/member/loginjz.aspx?ul=" style="margin-right: 6rem;">内部系统</a>丨
            <a href="https://exmail.qq.com/login" style="margin-left: 4rem;">企业邮箱</a>
          </div>
        </div>
      </van-popup>

      <!-- 移动端搜索栏 -->
      <van-popup v-model="phSearchShow" position="top" :style="{ height: '60%', width: '100%' }" :z-index="1500">
        <div class="ph_search">
          <div class="ps_top">
            <div></div>
            <div class="ps_logo"></div>
            <div class="ps_close">
              <div class="icon_close" @click="() => {
                phSearchShow = false;
              }
                "></div>
            </div>
          </div>
          <div class="ps_mid">
            <div class="ps_title">探索京哲</div>
            <div class="ps_inputArea">
              <input type="text" placeholder="搜索" v-model="searchText" />
              <div class="ps_rightArrow">
                <div class="ps_icon" @click="search(2)" v-loading="loading"></div>
              </div>
            </div>
            <div class="ps_label">京哲智慧，开启未来</div>
          </div>
        </div>
      </van-popup>

      <phoneDeclaration ref="myDeclarations"></phoneDeclaration>
    </div>
  </div>
</template>


<script>
import homePage01 from "./modules/homePage01.vue";
import homePage02 from "./modules/homePage02.vue";
import homePage03 from "./modules/homePage03.vue";
import homePage04 from "./modules/homePage04.vue";
import homePage05 from "./modules/homePage05.vue";
import homePage06 from "./modules/homePage06.vue";
import homePage07 from "./modules/homePage07.vue";
import homePage08 from "./modules/homePage08.vue";
import phonePage01 from "./modules/phonePage01.vue";
import phonePage02 from "./modules/phonePage02.vue";
import phonePage03 from "./modules/phonePage03.vue";
import phonePage04 from "./modules/phonePage04.vue";
import phonePage05 from "./modules/phonePage05.vue";
import phonePage06 from "./modules/phonePage06.vue";
import phonePage07 from "./modules/phonePage07.vue";
import phonePage08 from "./modules/phonePage08.vue";
export default {
  components: {
    homePage01,
    homePage02,
    homePage03,
    homePage04,
    homePage05,
    homePage06,
    homePage07,
    homePage08,
    phonePage01,
    phonePage02,
    phonePage03,
    phonePage04,
    phonePage05,
    phonePage06,
    phonePage07, phonePage08
  },
  data() {
    return {
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0, // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      phFullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0, // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      navShow: false,
      serchText: "",
      // 业务领域
      options: [],
      value: "",

      searchShow: false,
      currentTime: 0,

      // pcShow: true, //控制pc和移动端切换

      // 移动端
      phNavShow: false, //控制导航栏显示
      phSearchShow: false, //移动端搜索
      activeNames: "", //默认展开页

      // 搜索关键词
      searchText: '',
      loading: false,

      scroll: true,
    };
  },
  created() {
    // this.initData();
    // this.getfields();
    this.getCategorie();
  },
  activated() {
    this.phNavShow = false
  },

  mounted() { },
  methods: {
    // 初始化数据
    initData() {
      this.$axios.get(process.env.VUE_APP_API + "/api/v1/index").then((res) => {
        if (res.status === 200) {
          this.$tools.localStorageFn.set("PAGE_DATE", res.data);
        } else {
          this.$message.error(res.statusText);
        }
      });
    },
    // 获取业务领域列表
    getfields() {
      this.$axios
        .get(process.env.VUE_APP_API + "/api/v1/fields", { params: { per_page: 999 } })
        .then((res) => {
          console.log("业务领域", res);
          if (res.status === 200) {
            this.options = res.data;
            this.$tools.localStorageFn.set("FIELD_LIST", res.data.data);
          } else {
            this.$message.error(res.statusText);
          }
        });
    },
    // 获取所有栏目
    getCategorie() {
      this.$axios
        .get(process.env.VUE_APP_API + "/api/v1/categories")
        .then((res) => {
          console.log("所有栏目", res);
          if (res.status === 200) {
            this.$tools.localStorageFn.set("CATEGORIES_LIST", res.data);
          } else {
            this.$message.error(res.statusText);
          }
        });
    },
    jumpRouter(route) {
      if (this.$route.path == route) {
        this.$router.go(0);
      } else {
        this.$tools.blankPush(route);
      }
    },

    next() {
      // 往下切换
      let len = 8; // 页面的个数
      if (this.fullpage.current + 1 <= len) {
        // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
        this.fullpage.current += 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {
      // 往上切换
      if (this.fullpage.current - 1 > 0) {
        // 如果当前页面编号-1 大于0，则可以执行向下滑动
        this.fullpage.current -= 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    move(index) {
      this.$refs.homePage04.$refs.mySelect_3.blur();
      if (index == 7) {
        this.$refs.homePage07.moveShow = true;
      } else {
        this.$refs.homePage07.moveShow = false;
      }
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      setTimeout(() => {
        //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
        this.fullpage.isScrolling = false;
        this.scroll = true
      }, 1500);
    },
    directToMove(index) {
      if (!this.$refs["fullPage"]) {
        return;
      }
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      // scrollHeight = -(index - 1) * height + "px";
      let widthHeight = document.body.clientHeight;

      let footerHeight = document.getElementById("homePage08Box").offsetHeight;
      if (index == 8) {
        scrollHeight = "calc(" +
          (-(index - 2) * 100 +
            "%") + " - " + footerHeight + "px)";
      } else {
        scrollHeight = -(index - 1) * 100 + "%";
      }
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      scrollPage.style.transition = "all ease-out 0.75s";
      this.fullpage.current = index;
    },
    phNext() {
      // 往下切换
      let len = 8;
      if (this.phFullpage.current + 1 <= len) {
        // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
        this.phFullpage.current += 1; // 页面+1
        // let activePage = this.$refs["active"];
        // activePage.style.animation =
        //   "fade-in-bottom60b 1s ease 0s 1 normal none";
        this.phMove(this.phFullpage.current); // 执行切换
      }
    },
    phPre() {
      // 往上切换
      if (this.phFullpage.current - 1 > 0) {
        // 如果当前页面编号-1 大于0，则可以执行向下滑动
        this.phFullpage.current -= 1; // 页面+1
        // let activePage = this.$refs["active"];
        // activePage.style.animation = "fade-in-top60b 1s ease 0s 1 normal none";
        this.phMove(this.phFullpage.current); // 执行切换
      }
    },
    phMove(index) {
      this.$refs.phonePage04.$refs.phontSelect.blur();
      this.phFullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.phDirectToMove(index); //执行滚动
      setTimeout(() => {
        //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
        this.phFullpage.isScrolling = false;
      }, 1010);
    },
    phDirectToMove(index) {
      if (!this.$refs["phFullPage"]) {
        return;
      }
      let height = this.$refs["phFullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["phFullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      // scrollHeight = -(index - 1) * height + "px";
      let widthHeight = document.body.clientHeight;
      let footerHeight = document.getElementById("phonePage08Box").offsetHeight;
      if (index == 8) {
        scrollHeight = "calc(" +
          (-(index - 2) * 100 +
            "%") + " - " + footerHeight + "px)";
      } else {
        scrollHeight = -(index - 1) * 100 + "%";
      }
      // scrollHeight = -(index - 1) * 100 + "%";
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      scrollPage.style.transition = "all ease-out 0.75s";
      this.phFullpage.current = index;
    },
    mouseWheelHandle(event) {
      console.log('翻页', this.scroll)
      this.scroll = false
      // 监听鼠标监听
      // 添加冒泡阻止
      let width = document.body.clientWidth;

      let evt = event || window.event;
      if (evt.ctrlKey) {
        return;
      }
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        // 判断是否可以滚动
        return false;
      } else {
        let e = event.originalEvent || event;
        this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
        if (width > 1024) {
          if (this.fullpage.deltaY > 0) {
            this.next();
          } else if (this.fullpage.deltaY < 0) {
            this.pre();
          }
        } else {
          if (this.fullpage.deltaY > 0) {
            this.phNext();
          } else if (this.fullpage.deltaY < 0) {
            this.phPre();
          }
        }
      }
    },
    getWindowWidth(windowWidth) {
      if (windowWidth > 1024) {
        // this.pcShow = true;
        this.directToMove(this.fullpage.current);
      } else {
        let scrollPage = this.$refs["phFullPageContainer"]; // 获取执行tarnsform的元素
        scrollPage.style.transition = `none`;
      }
    },

    initCurrent() {
      let that = this;
      var test1 = setInterval(function () {
        that.currentTime += 200;
        if (that.currentTime > 28 * 200) {
          clearInterval(test1);
        }
      }, 200);
    },

    changeActive(event) {
      let list = document.getElementsByClassName("n_menuItem_detail");
      this.$refs.select.blur();
      for (let i = 0; i < list.length; i++) {
        list[i].style.width = "0";
      }
      let list02 = document.getElementsByClassName("n_menuItem_icon");
      for (let i = 0; i < list02.length; i++) {
        list02[i].classList.remove("n_menuItem_minus");
      }
      if (event.target.childNodes[1]) {
        event.target.childNodes[1].classList.add("n_menuItem_minus");
      }
      if (event.target.parentNode.childNodes[1]) {
        event.target.parentNode.childNodes[1].style.width =
          "calc(100% - 162px)";
      }
    },

    // 关闭导航弹窗
    closeNav() {
      this.navShow = false;
    },

    search(s) {
      if (this.searchText == '') {
        this.$message.warning('请输入搜索内容!')
        return
      } else {
        this.loading = true
        this.$axios.get(process.env.VUE_APP_API + '/api/v1/articles', {
          params: {
            filter: { title: this.searchText }
          }
        }).then((res) => {
          console.log('搜索结果', res)
          if (res.status == 200) {
            if (res.data.data.length == 0) {
              this.$message.warning('未查询任何数据!')
              return
            }
            if (s == 1) {
              this.$tools.blankPush('/jingzheDynamic?q=' + this.searchText)
            } else { this.$tools.blankPush('/mobileJingzheDynamic?q=' + this.searchText) }
          } else {
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.loading = false;
        });

      }
    }
  },
};
</script>

<style lang="scss">
.hpmePage {
  width: 100%;
  height: 100%;
  position: relative;

  .pcPage {
    .t_bar {
      z-index: 200;
      position: fixed;
      top: 6rem;
      width: 100%;
      padding: 0 7rem;
      display: flex;
      justify-content: space-between;

      .t_logo {
        width: 20.5rem;
        height: 4.5rem;
      }

      .t_logo02 {
        background: url(~@/assets/images/logo02.png) no-repeat center center;
        background-size: cover;
      }

      .t_logo03 {
        background: url(~@/assets/images/logo03.png) no-repeat center center;
        background-size: cover;
      }

      .t_placeholder {
        height: 4.5rem;
        display: flex;
        align-items: center;

        span {
          cursor: pointer;
        }

        .t_icon {
          cursor: pointer;
          width: 2.8rem;
          height: 2.8rem;
          display: inline-block;
          // margin-left: 3.4rem;
        }

        .t_menu {
          height: 2.6rem;
          margin: 0 3.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .t_menuitem {
            width: 2.8rem;
            height: 0.3rem;
            background: #fff;
          }

          .t_menuitem2 {
            // margin: calc((100% - 5..7rem) / 2) auto;
          }
        }

        .t_menu_blue {
          .t_menuitem {
            background: #013060;
          }
        }

        .t_menu:hover .t_menuitem2 {
          transform: translateX(-50%);
        }

        .t_icon_menu {
          background: url(~@/assets/images/icon_menu.png) no-repeat center center;
          background-size: cover;
        }

        .t_icon_menu02 {
          background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
          background-size: cover;
        }

        .t_icon_search01 {
          background: url(~@/assets/images/icon_search01.png) no-repeat center center;
          background-size: 100% 100%;
        }

        .t_icon_search02 {
          background: url(~@/assets/images/icon_search02.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .t_right {
        display: flex;
        align-items: center;

        // column-gap: 5.2rem;
        .mN_lage {
          margin-right: 5.2rem;
          font-size: 3rem;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: #fff;
        }

        .mN_lag {
          background: url(~@/assets/images/icon_language.png) no-repeat center center;
          background-size: 100% 100%;
          width: 2.8rem;
          height: 2.8rem;
          // margin-right: 5.2rem;
          font-size: 2rem;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: #fff;
          position: relative;

          .text {
            position: absolute;
            right: 0;
            bottom: 0;
            transform: translate(50%, 50%);
            font-size: 1.2rem;
            font-weight: 600;
          }
        }
      }

      .t_blue {
        color: #00305f !important;

        .mN_lag {
          background: url(~@/assets/images/icon_language02.png) no-repeat center center;
          background-size: 100% 100%;
        }

        .mN_lage,
        .mN_lag {
          color: #00305f !important;
        }
      }
    }

    // 目录
    .m_dire {
      position: absolute;
      bottom: 0;
      right: 6.6rem;
      bottom: 30%;

      .m_direItem {
        margin-bottom: 2rem;

        .m_direText {
          cursor: pointer;
          font-size: 1.2rem;
          font-family: SimHei;
          font-weight: 400;
          line-height: 1.4rem;
          color: #ffffff;
        }

        .m_direPoint {
          cursor: pointer;
          background: #fff;
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          margin-left: calc(100% - 0.5rem);
          position: relative;

          span {
            opacity: 0;
            transition: 0.6s;
            position: absolute;
            right: 0;
            top: -6px;
            font-size: 12px;
            white-space: nowrap;
            color: #fff;
          }
        }

        .m_direPoint:hover {
          background: transparent;

          span {
            opacity: 1;
          }
        }
      }
    }

    .m_direBlue {
      .m_direItem {
        .m_direText {
          color: #023060;
        }

        .m_direPoint {
          background: #033061;

          span {
            color: #033061;
          }
        }
      }
    }

    // 页面滚动
    .fullPage {
      height: 100vh; //一定要设置，保证占满
      overflow: hidden; //一定要设置，多余的先隐藏
    }

    .fullPageContainer {
      width: 100%;
      height: 100vh;
      // transition: all linear 0.75s;
    }

    .section {
      opacity: 0.5;
      transition: 1.5s 0.4s;
      width: 100vw;
      // height: calc(100% - .1rem);
      height: 100vh;
      // overflow: hidden;
      background-position: center center;
      background-repeat: no-repeat;
      position: relative;

      .b_left {
        z-index: 200;
        font-size: 1.9rem;
        font-family: SimHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.8rem;
        position: absolute;
        bottom: 5.7rem;
        left: 7.3rem;
      }

      .b_right_icon {
        cursor: pointer;
        z-index: 200;
        width: 3.3rem;
        height: 3.3rem;
        position: absolute;
        right: 6rem;
        bottom: 5.7rem;
      }

      .t_icon_backTop {
        background: url(~@/assets/images/icon_backTop.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_backTop02 {
        background: url(~@/assets/images/icon_backTop02.png) no-repeat center center;
        background-size: cover;
      }

      .t_blue {
        color: #013060 !important;
      }
    }

    .searchArea {
      height: 100%;
      background: #f8f8f8;
      padding: 4.8rem 6.8rem 0;
      position: relative;

      .s_searchIcon {
        position: absolute;
        right: 6.8rem;
        top: 4.8rem;
        width: 3.6rem;
        height: 3.6rem;
        background: #0e3a68;
        border-radius: 1.8rem;

        .s_close {
          margin: auto;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
          width: 1.4rem;
          height: 1.4rem;
          background: url(~@/assets/images/icon_close.png) no-repeat center center;
          background-size: cover;
        }
      }

      .s_nav {
        .s_logo {
          margin: 0 auto;
          width: 20.5rem;
          height: 4.5rem;
          background: url(~@/assets/images/logo03.png) no-repeat center center;
          background-size: cover;
        }
      }

      .s_title {
        margin-top: 6.9rem;
        font-size: 2.1rem;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #212121;
        line-height: 2.5rem;
        text-align: center;
        margin-bottom: 10.5rem;
      }

      .s_mid {
        width: 57rem;
        margin: 0 auto;

        .s_search {
          display: flex;
          justify-content: center;

          .s_input {
            input {
              background: transparent;
              width: 52rem;
              line-height: 3.6rem;
              font-size: 1.8rem;
              border: 0;
              border-bottom: 0.1rem solid rgba(14, 58, 104, 1);
            }
          }

          .s_goSearch {
            width: 3.2rem;
            height: 3.2rem;
            background: #0e3a68;
            border-radius: 1.6rem 1.6rem 1.6rem 1.6rem;
            margin-left: 0.8rem;

            .s_rightArrow {
              width: 1.6rem;
              height: 1.2rem;
              margin: 1rem auto;
              background: url(~@/assets/images/icon_rightArrow02.png) no-repeat center center;
              background-size: 100% 100%;
            }
          }
        }

        .s_label {
          margin-top: 1.8rem;
          padding-left: 0.2rem;
          font-size: 1.6rem;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: #0e3a68;
          line-height: 1.9rem;
        }
      }
    }

    // 动画
    // .n_area {
    //   .n_menuItem_detailItem n_bottom48 {
    //     opacity: 0;
    //   }
    //   .n_menuItem_label {
    //     opacity: 0;
    //   }
    //   .n_bottom48 {
    //     opacity: 1;
    //     animation-name: fade-in-bottom48;
    //     animation-duration: 0.5s;
    //     animation-timing-function: ease-in;
    //     animation-delay: 0s;
    //     animation-iteration-count: 1;
    //     animation-direction: normal;
    //     animation-fill-mode: none;
    //   }
    //   .n_right108 {
    //     animation-name: fade-in-right108;
    //     animation-duration: 1.5s;
    //     animation-timing-function: ease-in;
    //     animation-delay: 0s;
    //     animation-iteration-count: 1;
    //     animation-direction: normal;
    //     animation-fill-mode: none;
    //   }
    //   .n_left48 {
    //     opacity: 1;
    //     animation-name: fade-in-left48;
    //     animation-duration: 1s;
    //     animation-timing-function: ease-in;
    //     animation-delay: 0s;
    //     animation-iteration-count: 1;
    //     animation-direction: normal;
    //     animation-fill-mode: none;
    //   }
    // }
    .van-overlay {
      z-index: 1498 !important;
    }
  }

  /*屏幕宽度大于1920px,改变布局和样式*/
  @media screen and (min-width: 1920px) {
    .pcPage {
      .t_bar {
        z-index: 200;
        position: fixed;
        top: 6rem;
        width: 100%;
        padding: 0 70px;
        display: flex;
        justify-content: space-between;

        .t_logo {
          width: 205px;
          height: 45px;
        }

        .t_logo02 {
          background: url(~@/assets/images/logo02.png) no-repeat center center;
          background-size: cover;
        }

        .t_logo03 {
          background: url(~@/assets/images/logo03.png) no-repeat center center;
          background-size: cover;
        }

        .t_placeholder {
          height: 45px;
          display: flex;
          align-items: center;

          span {
            cursor: pointer;
          }

          .t_icon {
            cursor: pointer;
            width: 28px;
            height: 28px;
            display: inline-block;
            // margin-left: 34px;
          }

          .t_menu {
            height: 26px;
            margin: 0 35px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .t_menuitem {
              width: 28px;
              height: 3px;
              background: #fff;
            }

            .t_menuitem2 {
              // margin: calc((100% - 5.7px) / 2) auto;
            }
          }

          .t_menu_blue {
            .t_menuitem {
              background: #013060;
            }
          }

          .t_menu:hover .t_menuitem2 {
            transform: translateX(-50%);
          }

          .t_icon_menu {
            background: url(~@/assets/images/icon_menu.png) no-repeat center center;
            background-size: cover;
          }

          .t_icon_menu02 {
            background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
            background-size: cover;
          }

          .t_icon_search01 {
            background: url(~@/assets/images/icon_search01.png) no-repeat center center;
            background-size: 100% 100%;
          }

          .t_icon_search02 {
            background: url(~@/assets/images/icon_search02.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }

        .t_right {
          .mN_lage {
            margin-right: 52px;
            font-size: 30px;
          }

          .mN_lag {
            width: 28px;
            height: 28px;
            font-size: 20px;

            .text {
              font-size: 12px;
            }
          }
        }
      }

      // 目录
      .m_dire {
        position: absolute;
        bottom: 0;
        right: 66px;
        bottom: 30%;

        .m_direItem {
          margin-bottom: 20px;

          .m_direText {
            font-size: 12px;
            font-family: SimHei;
            font-weight: 400;
            line-height: 14px;
            color: #ffffff;
          }

          .m_direPoint {
            background: #fff;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            margin-left: calc(100% - 5px);
          }
        }
      }

      .m_direBlue {
        .m_direItem {
          .m_direText {
            color: #023060;
          }

          .m_direPoint {
            background: #033061;
          }
        }
      }

      // 页面滚动
      .fullPage {
        height: 100vh; //一定要设置，保证占满
        overflow: hidden; //一定要设置，多余的先隐藏
      }

      .fullPageContainer {
        width: 100%;
        height: 100vh;
        // transition: all linear 0.75s;
      }

      .section {
        opacity: 0.5;
        transition: 1.5s 0.4s;
        width: 100vw;
        // height: calc(100% - 1px);
        height: 100vh;
        overflow: hidden;
        background-position: center center;
        background-repeat: no-repeat;
        position: relative;

        .b_left {
          z-index: 200;
          font-size: 19px;
          font-family: SimHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 18px;
          position: absolute;
          bottom: 5.7rem;
          left: 7.3rem;
        }

        .b_right_icon {
          cursor: pointer;
          z-index: 200;
          width: 33px;
          height: 33px;
          position: absolute;
          right: 60px;
          bottom: 5.7rem;
        }

        .t_icon_backTop {
          background: url(~@/assets/images/icon_backTop.png) no-repeat center center;
          background-size: cover;
        }

        .t_icon_backTop02 {
          background: url(~@/assets/images/icon_backTop02.png) no-repeat center center;
          background-size: cover;
        }

        .t_blue {
          color: #013060 !important;
        }
      }

      // .n_area {
      //   height: 100%;
      //   overflow: hidden;
      //   display: flex;
      //   flex-direction: column;
      //   .n_nav {
      //     width: 100%;
      //     height: 14rem;
      //     // background: #013060;
      //     background: transparent;
      //     padding: 0 74px 0 55px;
      //     display: flex;
      //     justify-content: space-between;

      //     position: absolute;
      //     top: 0;
      //     .n_nav_right {
      //       display: flex;
      //       align-items: center;
      //       .n_nav_input {
      //         padding: 0 25px;
      //         width: 280px;
      //         height: 44px;
      //         background: rgba(64, 64, 81, 0);
      //         border: 1px solid #ffffff;
      //         display: flex;
      //         align-items: center;
      //         .n_input {
      //           background: rgba(64, 64, 81, 0);
      //           border: 0;
      //           font-size: 16px;
      //           font-family: SimHei;
      //           font-weight: 400;
      //           color: #ffffff;
      //           line-height: 19px;
      //         }
      //         .n_input::placeholder {
      //           color: #fff;
      //         }
      //         .n_icon_search01 {
      //           width: 22px;
      //           height: 22px;
      //           background: url(~@/assets/images/icon_search01.png) no-repeat
      //             center center;
      //           background-size: 100% 100%;
      //           margin-right: 11px;
      //         }
      //         .n_icon_rightArrow {
      //           width: 23px;
      //           height: 11px;
      //           background: url(~@/assets/images/icon_rightArrow.png) no-repeat
      //             center center;
      //           background-size: cover;
      //         }
      //       }
      //       .t_logo {
      //         width: 25.6rem;
      //         height: 5.6rem;
      //       }
      //       .t_logo02 {
      //         background: url(~@/assets/images/logo02.png) no-repeat center
      //           center;
      //         background-size: cover;
      //       }
      //       .t_logo03 {
      //         background: url(~@/assets/images/logo03.png) no-repeat center
      //           center;
      //         background-size: cover;
      //       }
      //     }
      //     .n_nav_left {
      //       display: flex;
      //       align-items: center;
      //       .n_lan {
      //         font-size: 16px;
      //         font-family: Microsoft YaHei UI;
      //         font-weight: 400;
      //         color: #ffffff;
      //         line-height: 19px;
      //         margin-right: 32px;
      //       }
      //       .el-icon-close {
      //         font-size: 32px;
      //         color: #013060;
      //       }
      //       // .n_icon_close {
      //       //   width: 16px;
      //       //   height: 16px;
      //       //   background: url(~@/assets/images/icon_close.png) no-repeat center
      //       //     center;
      //       //   background-size: 100% 100%;
      //       // }
      //     }
      //   }
      //   .n_menu {
      //     flex: 1;
      //     padding-top: 65px;
      //     padding-left: calc(25.6rem + 55px);
      //     background: url(~@/assets/images/navBg.jpg) no-repeat center center;
      //     background-size: 100% 100%;
      //     .n_menuItem {
      //       // display: flex;
      //       position: relative;
      //       margin-bottom: 16px;
      //       // align-items: center;
      //       .n_menuItem_label {
      //         cursor: pointer;
      //         white-space: nowrap;
      //         font-size: 2.8rem;
      //         font-family: SimHei;
      //         font-weight: 400;
      //         color: #013060;
      //         margin-right: 8.7rem;
      //         line-height: 7.2rem;
      //         display: flex;
      //         align-items: center;
      //         gap: 12px;
      //         .n_menuItem_icon {
      //           width: 1.8rem;
      //           height: 1.8rem;
      //           background: url(~@/assets/images/icon_add.png) no-repeat center
      //             center;
      //           background-size: 100% 100%;
      //         }
      //         .n_menuItem_minus {
      //           background: url(~@/assets/images/icon_minus02.png) no-repeat
      //             center center;
      //         }
      //       }
      //       .n_menuItem_detail {
      //         position: absolute;
      //         top: 0;
      //         left: 16.2rem;
      //         width: 0;
      //         flex-grow: 1; /*铺满剩余空间*/
      //         display: flex;
      //         overflow: hidden;
      //         // visibility: hidden;
      //         // display: none;
      //         align-items: center;
      //         flex-wrap: wrap;
      //         border-bottom: 1px dashed #cecece;
      //         .n_menuItem_detailItem {
      //           cursor: pointer;
      //           // visibility: hidden;
      //           // display: none;
      //           line-height: 6.4rem;
      //           width: calc(100% / 7);
      //           font-size: 1.3rem;
      //           font-family: Microsoft YaHei UI;
      //           font-weight: 400;
      //           color: #414151;
      //           white-space: nowrap;
      //         }
      //         .n_menuItem_search {
      //           margin: 1.8rem 0;
      //           display: flex;
      //           align-items: center;
      //           .n_menuItem_input {
      //             height: 3.4rem;
      //             input {
      //               vertical-align: top;
      //               box-sizing: border-box;
      //               padding: 0 11px;
      //               border-radius: 0;
      //               width: 17.6rem;
      //               height: 3.4rem;
      //               background: rgba(66, 66, 81, 0);
      //               border: 1px solid #777777;
      //               margin-right: 1rem;
      //               font-size: 1.3rem;
      //             }
      //             input::placeholder {
      //               font-size: 1.3rem;
      //               font-family: Microsoft YaHei UI;
      //               font-weight: 400;
      //               color: #777777;
      //               line-height: 3.4rem;
      //             }
      //             .el-input__suffix {
      //               right: 1rem;
      //               .el-input__suffix-inner {
      //                 position: relative;
      //                 // top: 0.3rem;
      //               }
      //             }
      //             .el-input__icon {
      //               line-height: 3.4rem;
      //             }
      //             .el-select .el-input .el-select__caret.is-reverse {
      //               position: relative;
      //               // bottom: 0.5rem;
      //             }
      //           }
      //           .n_menuItem_btn {
      //             width: 5.9rem;
      //             height: 3.4rem;
      //             background: #013060;
      //             font-size: 1.4rem;
      //             font-family: Microsoft YaHei UI;
      //             font-weight: 400;
      //             color: #ffffff;
      //             line-height: 3.4rem;
      //             text-align: center;
      //             margin-right: 3.4rem;
      //           }
      //         }
      //         .mb_24 {
      //           // margin-bottom: 24px;
      //         }
      //       }
      //       // .n_menuItem_detail:hover {
      //       //   visibility: visible;
      //       //   .n_menuItem_detailItem {
      //       //     // visibility: visible;
      //       //     display: block;
      //       //   }
      //       // }
      //     }
      //     // .n_menuItem:hover {
      //     //   // animation: height100 1s ease 0s 1 normal none;
      //     //   .n_menuItem_detail {
      //     //     width: calc(100% - 162px);
      //     //     // display: flex;
      //     //     .n_menuItem_detailItem {
      //     //       // visibility: visible;
      //     //       // display: block;
      //     //     }
      //     //   }
      //     // }
      //   }
      //   .el-select-dropdown__wrap {
      //     max-height: 1;
      //   }
      // }

      .searchArea {
        height: 100%;
        background: #f8f8f8;
        padding: 48px 68px 0;
        position: relative;

        .s_searchIcon {
          position: absolute;
          right: 68px;
          top: 48px;
          width: 36px;
          height: 36px;
          background: #0e3a68;
          border-radius: 18px;

          .s_close {
            margin: auto;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            width: 14px;
            height: 14px;
            background: url(~@/assets/images/icon_close.png) no-repeat center center;
            background-size: cover;
          }
        }

        .s_nav {
          .s_logo {
            margin: 0 auto;
            width: 205px;
            height: 45px;
            background: url(~@/assets/images/logo03.png) no-repeat center center;
            background-size: cover;
          }
        }

        .s_title {
          margin-top: 69px;
          font-size: 21px;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: #212121;
          line-height: 25px;
          text-align: center;
          margin-bottom: 105px;
        }

        .s_mid {
          width: 570px;
          margin: 0 auto;

          .s_search {
            display: flex;
            justify-content: center;

            .s_input {
              input {
                background: transparent;
                width: 520px;
                line-height: 36px;
                font-size: 18px;
                border: 0;
                border-bottom: 1px solid rgba(14, 58, 104, 1);
              }
            }

            .s_goSearch {
              width: 32px;
              height: 32px;
              background: #0e3a68;
              border-radius: 16px 16px 16px 16px;
              margin-left: 8px;

              .s_rightArrow {
                width: 16px;
                height: 12px;
                margin: 10px auto;
                background: url(~@/assets/images/icon_rightArrow02.png) no-repeat center center;
                background-size: 100% 100%;
              }
            }
          }

          .s_label {
            margin-top: 18px;
            padding-left: 2px;
            font-size: 16px;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: #0e3a68;
            line-height: 19px;
          }
        }
      }

      // 动画
      // .n_area {
      //   .n_menuItem_detailItem n_bottom48 {
      //     opacity: 0;
      //   }
      //   .n_menuItem_label {
      //     opacity: 0;
      //   }
      //   .n_bottom48 {
      //     opacity: 1;
      //     animation-name: fade-in-bottom48;
      //     animation-duration: 0.5s;
      //     animation-timing-function: ease-in;
      //     animation-delay: 0s;
      //     animation-iteration-count: 1;
      //     animation-direction: normal;
      //     animation-fill-mode: none;
      //   }
      //   .n_right108 {
      //     animation-name: fade-in-right108;
      //     animation-duration: 1.5s;
      //     animation-timing-function: ease-in;
      //     animation-delay: 0s;
      //     animation-iteration-count: 1;
      //     animation-direction: normal;
      //     animation-fill-mode: none;
      //   }
      //   .n_left48 {
      //     opacity: 1;
      //     animation-name: fade-in-left48;
      //     animation-duration: 1s;
      //     animation-timing-function: ease-in;
      //     animation-delay: 0s;
      //     animation-iteration-count: 1;
      //     animation-direction: normal;
      //     animation-fill-mode: none;
      //   }
      // }
      .van-overlay {
        z-index: 1498 !important;
      }
    }
  }

  .phonePage {
    display: none;
    position: relative;

    .pt_nav {
      z-index: 200;
      position: fixed;
      top: 2.3rem;
      width: 100%;
      padding: 0 2.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .pt_nav_left {
        width: 11.1rem;
        height: 2.5rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .pt_nav_right {
        display: flex;
        align-items: center;

        .pt_text {
          font-size: 1.3rem;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          line-height: 1.5rem;

          .mN_lag {
            background: url(~@/assets/images/icon_language.png) no-repeat center center;
            background-size: 100% 100%;
            width: 1.6rem;
            height: 1.6rem;
            // margin-right: 5.2rem;
            font-size: 0.2rem;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: #fff;
            position: relative;

            .text {
              position: absolute;
              right: 0;
              bottom: 0;
              transform: translate(50%, 50%);
              font-size: 0.8rem;
              font-weight: 600;
            }
          }
        }

        .t_blue {
          color: #00305f !important;

          .mN_lag {
            background: url(~@/assets/images/icon_language02.png) no-repeat center center;
            background-size: 100% 100%;
          }

          .mN_lag {
            color: #00305f !important;
          }
        }

        .pt_icon {
          width: 1.6rem;
          height: 1.6rem;
        }

        .icon_search02 {
          background: url(~@/assets/images/icon_search02.png) no-repeat center center;
          background-size: 100% 100%;
          margin-left: 1.7rem;
        }

        .icon_search01 {
          background: url(~@/assets/images/icon_search01.png) no-repeat center center;
          background-size: 100% 100%;
          margin-left: 1.7rem;
        }

        .icon_menu02 {
          background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
          background-size: 100% 100%;
          margin-left: 1.5rem;
        }

        .icon_menu {
          background: url(~@/assets/images/icon_menu.png) no-repeat center center;
          background-size: 100% 100%;
          margin-left: 1.5rem;
        }
      }
    }

    .pb_text {
      z-index: 200;
      width: 100%;
      position: fixed;
      bottom: 2.3rem;
      text-align: center;
      font-size: 1.1rem;
      font-family: SimHei;
      font-weight: 400;
      line-height: 1.3rem;
    }

    // 页面滚动
    .fullPage {
      height: 100vh; //一定要设置，保证占满
      overflow: hidden; //一定要设置，多余的先隐藏
    }

    .fullPageContainer {
      width: 100%;
      height: 100vh;
    }

    .section {
      width: 100vw;
      // height: calc(100% - 1rem);
      height: 100vh;
      overflow: hidden;
      background-position: center center;
      background-repeat: no-repeat;
    }

    // 导航
    .phNav {
      position: relative;
      min-height: 100%;
      width: 100%;

      .pn_top {
        padding: 1.2rem 2.3rem;
        background: #013060;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .pnh_tr {
          display: flex;
          padding: 0 0.9rem;
          align-items: center;
          background: rgba(64, 64, 81, 0);
          border: 0.1rem solid #ffffff;

          .pnh_search01 {
            width: 1.5rem;
            height: 1.5rem;
            background: url(~@/assets/images/icon_search01.png) no-repeat center center;
            background-size: 100% 100%;
            margin-right: 0.7rem;
          }

          input {
            width: 13.3rem;
            background: transparent;
            font-size: 1.2rem;
            font-family: SimHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 2.9rem;
            border: 0;
          }

          input::placeholder {
            color: #ffffff;
          }

          .pnh_rightArrow {
            width: 1.7rem;
            height: 0.8rem;
            background: url(~@/assets/images/icon_rightArrow.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }

        .pnh_tl {
          display: flex;
          align-items: center;

          .ptl_text {
            margin: 0;
            padding: 0;
            font-size: 1.3rem;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: #ffffff;
            line-height: 1.5rem;

            .mN_lag {
              background: url(~@/assets/images/icon_language.png) no-repeat center center;
              background-size: 100% 100%;
              width: 1.6rem;
              height: 1.6rem;
              // margin-right: 5.2rem;
              font-size: 0.2rem;
              font-family: Microsoft YaHei UI;
              font-weight: 400;
              color: #fff;
              position: relative;

              .text {
                position: absolute;
                right: 0;
                bottom: 0;
                transform: translate(50%, 50%);
                font-size: 0.8rem;
                font-weight: 600;
              }
            }
          }

          .pnh_close {
            margin-left: 2.6rem;
            width: 1.2rem;
            height: 1.2rem;
            background: url(~@/assets/images/icon_close.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
      }

      .pn_area {
        padding: 2.0rem 2.3rem;
        padding-bottom: 8.8rem;

        .pn_icons {
          display: flex;
          align-items: center;
        }

        .pn_plus {
          background: url(~@/assets/images/icon_plus.png) no-repeat center center;
          background-size: 100% 100%;
          width: 1.2rem;
          height: 1.2rem;
        }

        .pm_inputArea {
          // transform: translateY(60rem);
          // opacity: 0;
          // transition: 1s 0.6s;
          display: flex;
          flex-direction: column;
          row-gap: 1.3rem;
          padding: 1.2rem 0;

          .pm_inputItem {
            display: flex;
            align-items: center;
            column-gap: 0.8rem;

            .btn {
              display: inline-block;
              width: 16%;
              height: 3.4rem;
              background: #033061;
              color: #fff;
              font-size: 1.2rem;
              line-height: 3.4rem;
              text-align: center;
            }
          }

          input {
            height: 3.4rem;
            box-sizing: border-box;
            width: 80%;
            border: 0.1rem solid #033061;
            // margin-bottom: 13rem;
            padding: 1.1rem;
          }

          input::placeholder {
            font-size: 1.2rem;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: #023060;
            line-height: 1.4rem;
          }

          .pm_select {
            box-sizing: border-box;
            width: 100%;
            border: 0.1rem solid #033061;
            padding: 1.1rem 1.7rem 1.1rem 1.1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 1.2rem;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: #023060;
            line-height: 1.4rem;
            margin-bottom: 1.9rem;
          }

          .el-select {
            width: 80%;

            .el-input {
              border: 0.1rem solid #033061;

              input {
                height: 3.2rem;
                background: rgba(68, 68, 68, 0);
                margin: 0;
                // height: 52px;
                // line-height: 52px;
                border-radius: 0;
                border: none;
                padding: 1.1rem;
                font-size: 1.2rem;
              }

              input::placeholder {
                color: #033061;
                // font-size: 16px;
              }

              .el-input__suffix {
                right: 1.2rem;

                .el-input__icon {
                  font-size: 1.2rem;
                  line-height: 3.4rem;
                  color: #093665;
                }
              }
            }
          }
        }

        .van-hairline--top-bottom::after {
          border: 0;
        }

        .van-collapse-item {
          border-bottom: 0.1rem solid #013060;

          .van-cell {
            padding: 1.7rem 0.2rem;

            .van-cell__title {
              font-size: 2.2rem;
              font-family: JingZhe_XiaoWei;
              font-weight: 400;
              color: #013060;
              line-height: 2.2rem;
            }
          }

          .van-cell::after {
            border: 0;
          }

          .van-collapse-item__content {
            padding: 0.3rem 0.4rem;

            ul {
              li {
                font-size: 1.8rem;
                font-family: JingZhe_XiaoWei;
                font-weight: 400;
                color: #3f3f51;
                line-height: 1.8rem;
                margin-bottom: 1.5rem;
              }
            }
          }
        }

        .van-collapse-item:first-child {
          .van-cell::after {
            border: none;
          }
        }

        .van-collapse-item__title--expanded {
          .pn_plus {
            background: url(~@/assets/images/icon_minus.png) no-repeat center center;
            background-size: 100% 100%;
            width: 1.2rem;
            height: 0.2rem;
          }
        }
      }

      .pn_footer {
        position: absolute;
        font-size: 1.8rem;
        left: 2.3rem;
        bottom: 4.8rem;
        font-family: JingZhe_XiaoWei;

        a {
          color: #013060;
        }
      }
    }

    .van-overlay {
      z-index: 1498 !important;
    }

    //搜索
    .ph_search {
      width: 100%;
      height: 100%;
      padding: 2.9rem 2.3rem 0 4.0rem;
      background: #f8f8f8;

      .ps_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5.6rem;

        .ps_logo {
          width: 15.0rem;
          height: 3.3rem;
          background: url(~@/assets/images/logo01.png) no-repeat center center;
          background-size: 100% 100%;
        }

        .ps_close {
          width: 2.5rem;
          height: 2.5rem;
          background: #0e3a68;
          border-radius: 1.2rem;
          display: flex;
          align-items: center;

          .icon_close {
            margin: auto;
            width: 0.9rem;
            height: 0.9rem;
            background: url(~@/assets/images/icon_close.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
      }

      .ps_mid {
        .ps_title {
          text-align: center;
          font-size: 1.5rem;
          font-family: Microsoft YaHei UI;
          font-weight: bold;
          color: #202020;
          line-height: 1.8rem;
          margin-bottom: 4.2rem;
        }

        .ps_inputArea {
          display: flex;
          align-items: center;
          margin-bottom: 1.4rem;

          input {
            width: 28.1rem;
            font-size: 1.2rem;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: #868686;
            line-height: 4.0rem;
            border: 0;
            border-bottom: 0.1rem solid #212121;
            background: transparent;
          }

          input::after {
            color: #868686;
          }

          .ps_rightArrow {
            width: 2.3rem;
            height: 2.3rem;
            background: #0e3a68;
            border-radius: 1.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 1.3rem;

            .ps_icon {
              width: 1.2rem;
              height: 0.9rem;
              background: url(~@/assets/images/icon_rightArrow.png) no-repeat center center;
              background-size: 100% 100%;
            }
          }
        }

        .ps_label {
          font-size: 1.2rem;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: #0e3a68;
          line-height: 1.4rem;
        }
      }
    }
  }
}

.pointer {
  cursor: pointer;
}

.active {
  opacity: 1 !important;
  transform: opacity;
}

/*屏幕宽度小于1024px,改变布局和样式*/
@media screen and (max-width: 1024px) {
  .pcPage {
    display: none;
  }

  .phonePage {
    display: block !important;
  }
}
</style>